var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataLoaded)?_c('detail-view',{attrs:{"config":_vm.config},on:{"save":_vm.save}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }